import React, { useContext } from 'react';
import 'antd/dist/antd.min.css';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { SettingOutlined, AreaChartOutlined } from '@ant-design/icons';
import { AuthContext } from 'shared/context/auth-context';

const { SubMenu } = Menu;

export default function Sidebar() {
  const { roleUser } = useContext(AuthContext);
  const allRoles = ['AnyTimeAdmin', 'AnyTime', 'GT'];
  const location = useLocation();

  const menu = [
    {
      key: 'options',
      icon: <SettingOutlined />,
      title: 'Επιλογές',
      role: allRoles,
      menuItems: [
        {
          key: 'insuranceContracts',
          link: <Link to="/choices/search-insurance-contracts" />,
          title: 'Ασφαλιστήρια Συμβόλαια',
          role: allRoles
        },
        {
          key: 'packingList',
          title: 'Packing List',
          role: ['GT'],
          submenus: [
            {
              key: 'packingListObd',
              title: 'Packing List Obd',
              link: <Link to="/choices/packing-list/packingObd" />,
              role: ['GT']
            },
            {
              key: 'packingListBluetooth',
              title: 'Packing List Bluetooth',
              link: <Link to="/choices/packing-list/packingBl" />,
              role: ['GT']
            },
            {
              key: 'updateOpenPacking',
              title: 'Επεξεργασία Ανοιχτού Κιβωτίου',
              link: <Link to="/choices/packing/updatePacking" />,
              role: ['GT']
            },
            {
              key: 'deviceOverview',
              title: 'Επισκόπηση Συσκευών',
              link: <Link to="/choices/packing-list/device-overview" />,
              role: ['GT']
            },
            {
              key: 'deviceStatusTracking',
              title: 'Έλεγχοι Status Συσκευών',
              link: <Link to="/choices/packing-list/device-status-tracking" />,
              role: ['GT']
            },
            {
              key: 'deviceTripsTracking',
              title: 'Έλεγχοι Διαδρομών Συσκευών',
              link: <Link to="/choices/packing-list/device-trips-tracking" />,
              role: ['GT']
            }
          ]
        },
        {
          key: 'fileImport',
          link: <Link to="/choices/file-import" />,
          title: 'Εισαγωγή Αρχείου',
          role: ['GT']
        },
        {
          key: 'uploadEmissions',
          link: <Link to="/choices/upload-excel-emissions" />,
          title: 'Εισαγωγή Αρχείου Εκπομπών',
          role: ['GT']
        },
        {
          key: 'uploadDevicesForReset',
          link: <Link to="/choices/upload-excel-device-reset" />,
          title: 'Εισαγωγή Συσκευών',
          role: ['GT']
        },
        {
          key: 'deleteKilometers',
          link: <Link to="/choices/delete-kilometers" />,
          title: 'Μαζική Διαγραφή Χιλιομέτρων',
          role: ['GT']
        },
        {
          key: 'configuration',
          title: 'Παραμετροποίηση',
          role: ['GT'],
          submenus: [
            {
              key: 'configurationMessages',
              title: 'Μηνυμάτων',
              link: <Link to="/choices/message" />,
              role: ['GT']
            },
            {
              key: 'configurationDevices',
              title: 'Συσκευών',
              link: <Link to="/choices/configDevice?PackingStatusId=3" />,
              role: ['GT']
            }
          ]
        },
        {
          key: 'installationGuide',
          link: <Link to="/choices/installation-guide" />,
          title: 'Οδηγίες Εγκατάστασης',
          role: allRoles
        }
      ]
    },
    {
      key: 'statistics',
      icon: <AreaChartOutlined />,
      title: 'Στατιστικά',
      role: ['GT'],
      submenus: [
        {
          key: 'customerReports',
          title: 'Αναφορές Πελατών',
          menuItems: [
            {
              key: 'customerReportsStatus',
              link: <Link to="/statistics/customer-reports/status" />,
              title: 'Κατάσταση',
              role: ['GT']
            },
            {
              key: 'customerReportsSms',
              link: <Link to="/statistics/customer-reports/sms" />,
              title: 'SMS',
              role: ['GT']
            },
            {
              key: 'customerReportsTrips',
              link: <Link to="/statistics/customer-reports/trips" />,
              title: 'Διαδρομές',
              role: ['GT']
            },
            {
              key: 'customerReportsAlarms',
              link: <Link to="/statistics/customer-reports/alarms" />,
              title: 'Alarms',
              role: ['GT']
            },
            {
              key: 'customerReportsVehicles',
              link: <Link to="/statistics/customer-reports/vehicles" />,
              title: 'Οχήματα',
              role: ['GT']
            },
            {
              key: 'customerReportsPermissions',
              link: <Link to="/statistics/customer-reports/permissions" />,
              title: 'Άδειες',
              role: ['GT']
            },
            {
              key: 'customerReportsHeartbeat',
              link: <Link to="/statistics/customer-reports/heartbeat" />,
              title: 'Κατάσταση Εφαρμογών',
              role: ['GT']
            },
            {
              key: 'customerReportsDeviceStatus',
              link: <Link to="/statistics/customer-reports/deviceStatus" />,
              title: 'Κατάσταση Συσκευών',
              role: ['GT']
            },
            {
              key: 'customerReportsNoLogin',
              link: <Link to="/statistics/customer-reports/nologin" />,
              title: 'NoLogin',
              role: ['GT']
            },
            {
              key: 'customerReportsNoPaired',
              link: <Link to="/statistics/customer-reports/nopaired" />,
              title: 'NoPaired',
              role: ['GT']
            },
            {
              key: 'customerReportsEmissions',
              link: <Link to="/statistics/customer-reports/emissions" />,
              title: 'Εκπομπές Ρύπων',
              role: ['GT']
            }
          ]
        }
      ]
    }
  ];

  const getMenu = menu
    .filter(item => item.role?.indexOf(roleUser) !== -1)
    .map(({ key, icon, title, menuItems, submenus }) => (
      <SubMenu key={key} icon={icon} title={title}>
        {submenus?.map(subMenuItem => (
          <SubMenu key={subMenuItem.key} title={subMenuItem.title}>
            {subMenuItem.menuItems
              ?.filter(item => item.role.indexOf(roleUser) !== -1)
              .map(subMenuSubItem => (
                <Menu.Item key={subMenuSubItem.key}>
                  {subMenuSubItem.link}
                  {subMenuSubItem.title}
                </Menu.Item>
              ))}
          </SubMenu>
        ))}
        {menuItems
          ?.filter(item => item.role.indexOf(roleUser) !== -1)
          .map(menuItem =>
            menuItem.submenus ? (
              <SubMenu key={menuItem.key} title={menuItem.title}>
                {menuItem.submenus
                  .filter(item => item.role.indexOf(roleUser) !== -1)
                  .map(submenuItem => (
                    <Menu.Item key={submenuItem.key}>
                      {submenuItem.link}
                      {submenuItem.title}
                    </Menu.Item>
                  ))}
              </SubMenu>
            ) : (
              <Menu.Item key={menuItem.key}>
                {menuItem.link}
                {menuItem.title}
              </Menu.Item>
            )
          )}
      </SubMenu>
    ));

  return (
    <Menu
      defaultOpenKeys={location.state?.keyPath}
      defaultSelectedKeys={location.state?.keyPath}
      style={{ height: '100%', borderRight: 0 }}
      mode="inline"
    >
      {getMenu}
    </Menu>
  );
}
